// extracted by mini-css-extract-plugin
export default {"ocean":"wave_ocean__Bo7pJ","wave":"wave_wave__TI9zj","wave2":"wave_wave2__CqKFY","swell":"wave_swell__+U-9L"};